import { HUBS } from '../../types/relevancyData';
const USER_PERSONAS = {
  ADMIN: 'admin',
  DEVELOPER: 'developer',
  VIEW_ONLY: 'view-only',
  PARTNER: 'partner',
  SALES_REP: 'sales-rep',
  SALES_MANAGER: 'sales-manager',
  SALES: 'sales',
  MARKETING_REP: 'marketing-rep',
  MARKETING_MANAGER: 'marketing-manager',
  MARKETING: 'marketing',
  SERVICE_REP: 'service-rep',
  SERVICE_MANAGER: 'service-manager',
  SERVICE: 'service'
};
export const USER_PERSONA_RELEVANCY_DATA = {
  [USER_PERSONAS.SALES_REP]: {
    hubs: [HUBS.SALES]
  },
  [USER_PERSONAS.SALES_MANAGER]: {
    hubs: [HUBS.SALES]
  },
  [USER_PERSONAS.SALES]: {
    hubs: [HUBS.SALES]
  },
  [USER_PERSONAS.MARKETING_REP]: {
    hubs: [HUBS.MARKETING]
  },
  [USER_PERSONAS.MARKETING_MANAGER]: {
    hubs: [HUBS.MARKETING]
  },
  [USER_PERSONAS.MARKETING]: {
    hubs: [HUBS.MARKETING]
  },
  [USER_PERSONAS.SERVICE_REP]: {
    hubs: [HUBS.SERVICE]
  },
  [USER_PERSONAS.SERVICE_MANAGER]: {
    hubs: [HUBS.SERVICE]
  },
  [USER_PERSONAS.SERVICE]: {
    hubs: [HUBS.SERVICE]
  }
};